import { ColDef } from 'ag-grid-community';

export const BoundBookColumnDef: ColDef[] = [
  {
    // State
    headerName: 'State',
    field: 'state',
    resizable: true,
    width: 120,
    tooltipValueGetter: getToolTip,
    filter: 'agTextColumnFilter',
    cellRenderer: 'StateBadge',
  },
  {
    // Bound Book id
    headerName: 'Bound Book id',
    field: 'bound_book_id',
    resizable: true,
    width: 125,
    tooltipField: 'bound_book_id',
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    // Firearm ID
    headerName: 'Firearm ID',
    field: 'firearm_id',
    resizable: true,
    width: 125,
    tooltipField: 'firearm_id',
    filter: 'agTextColumnFilter',
  },
  {
    // Firearm
    headerName: 'Firearm',
    field: 'firearm',
    resizable: true,
    tooltipField: 'firearm',
    filter: 'agTextColumnFilter',
    flex: 1,
    valueFormatter: (params) => params.value ? params.value.toUpperCase() : '',
  },
  {
    // Serial #
    headerName: 'Serial #',
    field: 'serial_number',
    resizable: true,
    width: 130,
    tooltipField: 'serial_number',
    filter: 'agTextColumnFilter',
    valueFormatter: (params) => params.value ? params.value.toUpperCase() : '',
  },
  {
    // Received From / Transferred To
    headerName: 'Received From / Transferred To',
    valueGetter: (params) => {
      if (params.data.state === 'D') {
        return `${params.data.received_from} / ${params.data.transfered_to}`;
      }
      return params.data.received_from;
    },
    resizable: true,
    width: 300,
    tooltipValueGetter: (params) => {
      if (params.data.state === 'D') {
        return `${params.data.received_from} / ${params.data.transfered_to}`;
      }
      return params.data.received_from;
    },
    filter: 'agTextColumnFilter',
    cellRenderer: (params: any) => {
      const received = params.data.received_from;
      if (params.data.state === 'D') {
        const transfered = params.data.transfered_to
          ? params.data.transfered_to
          : params.data.transfered_to;
        const form_4473_transfer_number = params.data.form_4473_transfer_number;
        const transfer_num_display = form_4473_transfer_number
          ? `${form_4473_transfer_number} - `
          : '';

        return `${received} / <span style="color: coral; ">${transfer_num_display}${transfered}</span>`;
      }
      return received;
    },
  },
  {
    // Date Received/Transferred
    headerName: 'Date Received/Transferred',
    valueGetter: (params) => {
      if (params.data.state === 'D') {
        return `${params.data.date_acquired} / ${params.data.date_disposed}`;
      }
      return params.data.date_acquired;
    },
    resizable: true,
    width: 225,
    tooltipValueGetter: (params) => {
      if (params.data.state === 'D') {
        return `${params.data.date_acquired} / ${params.data.date_disposed}`;
      }
      return params.data.date_acquired;
    },
    filter: 'agTextColumnFilter',
    cellRenderer: (params: any) => {
      const acquired = params.data.date_acquired;
      if (params.data.state === 'D') {
        const disposed = params.data.date_disposed;
        return `${acquired} / <span style="color: coral;">${disposed}</span>`;
      }
      return acquired;
    },
  },
  {
    // d_id
    headerName: 'd_id',
    field: 'd_id',
    resizable: true,
    width: 125,
    tooltipField: 'd_id',
    filter: 'agTextColumnFilter',
    hide: true,
  },
];

export function getStateAbbreviationCellStyle(params: any): any {
  if (params.data.state === 'A') {
    return { color: 'darkseagreen' }; // Change the color to red when the state is 'Available'
  } else if (params.data.state === 'D') {
    return { color: 'coral' }; // Change the color to red when the state is 'Destroy'
  } else if (params.data.state === 'I') {
    return { color: 'darkturquoise' }; // Change the color to red when the state is 'In Progress'
  } else if (params.data.state === 'L') {
    return { color: 'red' }; // Change the color to red when the state is 'Lost Stolen'
  } else if (params.data.state === 'R') {
    return { color: 'orange' }; // Change the color to red when the state is 'Reserved'
  } else if (params.data.state === 'S') {
    return { color: 'purple' }; // Change the color to red when the state is 'Store Use'
  }
  return null; // Return null for default styling
}

export function getToolTip(params: any): any {
  if (params.data.state === 'A') {
    return 'Available'; // Change the color to red when the state is 'Available'
  } else if (params.data.state === 'D') {
    return `Dispo'd`; // Change the color to red when the state is 'Destroy'
  } else if (params.data.state === 'I') {
    return 'In Progress'; // Change the color to red when the state is 'In Progress'
  } else if (params.data.state === 'L') {
    return 'Lost / Stolen'; // Change the color to red when the state is 'Lost Stolen'
  } else if (params.data.state === 'R') {
    return 'Reserved'; // Change the color to red when the state is 'Reserved'
  } else if (params.data.state === 'S') {
    return 'Store Use'; // Change the color to red when the state is 'Store Use'
  }
  return null; // Return null for default styling
}
